import styled from "styled-components";

interface Step3Props {
  check1: boolean;
  check2: boolean;
  handleCheck1: () => void;
  handleCheck2: () => void;
}

const Step3 = ({ check1, check2, handleCheck1, handleCheck2 }: Step3Props) => (
  <TermsDiv>
    <TermsRow>
      <TermsLabel>
        <TermsCheckbox type="checkbox" checked={check1} onChange={handleCheck1} />
        <span>[필수] 서비스 이용약관 동의</span>
      </TermsLabel>
      <DetailLink href="/rule-seller/1" target="_blank" rel="noopener noreferrer" aria-label="서비스 이용약관 보기">
        보기 <Chevron />
      </DetailLink>
    </TermsRow>
    <TermsRow>
      <TermsLabel>
        <TermsCheckbox type="checkbox" checked={check2} onChange={handleCheck2} />
        <span>[필수] 개인정보 처리 방침 동의</span>
      </TermsLabel>
      <DetailLink href="/rule-seller/2" target="_blank" rel="noopener noreferrer" aria-label="개인정보 처리 방침 보기">
        보기 <Chevron />
      </DetailLink>
    </TermsRow>
  </TermsDiv>
);

function Chevron() {
  return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="m6 4 4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>;
}

export default Step3;

const TermsDiv = styled.div`
  display: grid;
  gap: var(--space-4);
`;
const TermsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
`;
const TermsLabel = styled.label`
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(--space-3);
  min-width: 0;
  min-height: var(--touch-target);
  font-size: var(--text-body);
  line-height: var(--leading-body);
  word-break: keep-all;
  cursor: pointer;
`;
const TermsCheckbox = styled.input`
  flex-shrink: 0;
  width: var(--space-5);
  height: var(--space-5);
  margin: 0;
  accent-color: var(--color-brand);
  cursor: pointer;
`;
const DetailLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: var(--space-1);
  min-width: var(--touch-target);
  min-height: var(--touch-target);
  color: var(--color-text-secondary);
  font-size: var(--text-caption);
  line-height: var(--leading-caption);
  text-decoration: none;
  &:hover { color: var(--color-text-link); }
`;
